export const CampaignNegativeKeyword = {
  parent: 'Campaign',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Campaign Negative Keyword',
    },
    Text: {
      'bulk-upload-header': 'Keyword',
    },
    MatchType: {
      'bulk-upload-header': 'Match Type',
    },
  },
};
